import * as React from "react";
import styles from "./style.module.scss";

interface Props {
  fullScreen?: boolean;
  className?: string;
  style?: any;
}

export const Loader: React.FC<Props> = ({ fullScreen, className = "", style = {} }) => {
  return <div className={`${styles.loader} ${!!fullScreen ? styles.fullScreen : ""} ${className}`} style={style} />;
};
